import {Formik, Form} from 'formik'
import * as Yup from 'yup'
import FormikControl from '../../../components/formikControl/FormikControl'
import toast from 'react-hot-toast'
import {addGPStoBus, getGPS} from './api'
import {useQuery} from 'react-query'
import {RunnerBall} from '../../../components/FormLoader'
import {handleApiError} from '../../../helpers/errorHandler'
import FormResetBtn from '../../../components/FormResetBtn'
import FormSubmitBtn from '../../../components/FormSubmitBtn'

function GPS({initialValues: busDetails, onAfterSubmit}) {
  const {data, isFetching} = useQuery('gps', () => getGPS(busDetails.bus_id), {
    refetchOnWindowFocus: false,
  })
  if (isFetching) {
    return <RunnerBall />
  }

  const device = data?.data

  const submitHandler = (values, {setSubmitting: setLoading}) => {
    setLoading(true)
    const toastId = toast.loading('Submitting')

    addGPStoBus({
      bus_id: values.bus_id,
      device_id: values.device_id,
      powerboard_id: values.powerboard_id,
    })
      .then(() => {
        toast.success('Success', {id: toastId})
        onAfterSubmit()
      })
      .catch((err) => {
        handleApiError(err, toastId)
      })
      .finally((res) => setLoading(false))
  }
  const formValues = {
    device_id: device?.device_id || '',
    powerboard_id: device?.powerboard_id || '',
    bus_name: busDetails.bus_name + ' - ' + busDetails.bus_registration_number,
    bus_id: busDetails.bus_id,
  }
  return (
    <div className="px-5 py-3">
      <Formik
        initialValues={formValues}
        validationSchema={Yup.object({
          device_id: Yup.string()
            .trim()
            .required('Device Id is required')
            .notOneOf([''], 'Device Id is Required'),
          powerboard_id: Yup.string()
            .trim()
            .required('Powerboard Device Id is required')
            .notOneOf([''], 'Powerboard Device Id is required'),
        })}
        onSubmit={submitHandler}
      >
        {({isSubmitting, resetForm, dirty, isValid}) => (
          <Form>
            <FormikControl
              control="input"
              placeholder="Bus"
              label="Bus Brand"
              name="bus_name"
              disabled
            />
            <FormikControl
              control="input"
              required
              placeholder="Device Id"
              label="Device Id"
              name="device_id"
            />
            <FormikControl
              control="input"
              required
              placeholder="Powerboard Device Id"
              label="Powerboard Device Id"
              name="powerboard_id"
            />

            <div className="text-center pt-10">
              <FormResetBtn onClick={() => resetForm} disabled={isSubmitting} className="me-4" />

              <FormSubmitBtn disabled={!isValid || isSubmitting} />
            </div>
          </Form>
        )}
      </Formik>
    </div>
  )
}

export default GPS
